module.exports = "<div id=\"error\" [ngClass]='Position === \"top\" ? \"top Aligner\" : (Position === \"bottom\" ? \"bottom\" : \"\")'  [class]=\"Class\" [@visibilityChanged]=\"haveMessage\">\r\n    <div [ngClass]='{\"errortext\": isError, \"messagetext\": !isError}'  >\r\n        {{message}}\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/message/message.component.html
// module id = 8Jyn
// module chunks = 7